"use strict";
// Copyright (c) Microsoft Corporation.
// Licensed under the MIT License.
Object.defineProperty(exports, "__esModule", { value: true });
exports.SDK_INFO = void 0;
/**
 * SDK info
 * @internal
 */
exports.SDK_INFO = {
    NAME: "opentelemetry",
    RUNTIME: "node",
    LANGUAGE: "nodejs",
};
//# sourceMappingURL=constants.js.map